"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpPerformHeader = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const PassStatus_1 = __importDefault(require("@opsbase/lib-grading/PassStatus"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const usePerform_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerform"));
const usePerformActions_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerformActions"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf/useSelf"));
const DataPill_1 = __importDefault(require("@opsbase/web-chips/DataPill"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const FailIcon_1 = __importDefault(require("@opsbase/web-icons/icons/FailIcon"));
const PassIcon_1 = __importDefault(require("@opsbase/web-icons/icons/PassIcon"));
const PlayIcon_1 = __importDefault(require("@opsbase/web-icons/icons/PlayIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const PercentCircle_1 = __importDefault(require("@opsbase/web-ui/PercentCircle"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const PickStaffDialog_1 = __importDefault(require("../PickStaffDialog"));
const makeMyClasses = showCompleteBar => ({
    root: {
        backgroundColor: lib_palette_1.default.White.main,
        boxShadow: showCompleteBar ? undefined : `0 0 24px -4px ${lib_palette_1.default.BlackCoral.main}`,
    },
    topBar: {
        backgroundColor: lib_palette_1.default.White.main,
        padding: 16,
        zIndex: 2,
    },
    completedBar: {
        opacity: showCompleteBar ? 1 : 0,
        position: 'relative',
        boxShadow: showCompleteBar ? `0 0 24px -4px ${lib_palette_1.default.BlackCoral.main}` : undefined,
        transition: 'opacity 0.3s, margin-top 0.3s',
        zIndex: 1,
    },
    completedMsg: {
        opacity: showCompleteBar ? 1 : 0,
        transition: 'opacity 0.3s',
    },
    notCompletedMsg: {
        opacity: showCompleteBar ? 0 : 1,
        transition: 'opacity 0.3s',
    },
    nativeOnlyMessage: {
        background: lib_palette_1.default.White.main,
    },
    submitButton: { border: '4px solid white', height: 48, borderRadius: 24 },
});
function OpPerformHeader({ children, submitButton: propsSubmitButton, submitMessage, }) {
    const { submitting, saving, title, placeTitle, isSubmitted, isCompleted, percentCompleted, isPassStatusAvailable, passStatus, isScoreAvailable, isGradeAvailable, scoreText, grade, canBePerformedOnlyOnNative, hasError } = (0, usePerform_1.default)();
    const { doSubmit, doUpdateSubmittingUser, doSetUserImage } = (0, usePerformActions_1.default)();
    const myCss = (0, web_css_1.default)(makeMyClasses, [isCompleted && !isSubmitted]);
    const [showStaffListDialog, setShowStaffListDialog] = (0, react_1.useState)(false);
    const self = (0, useSelf_1.default)();
    const passFailIcon = (0, react_1.useMemo)(() => {
        if (!isPassStatusAvailable)
            return null;
        if (passStatus === PassStatus_1.default.PASS)
            return react_1.default.createElement(PassIcon_1.default, Object.assign({}, passFailIconProps, { color: lib_palette_1.default.positive }));
        if (passStatus === PassStatus_1.default.FAIL)
            return react_1.default.createElement(FailIcon_1.default, Object.assign({}, passFailIconProps, { color: lib_palette_1.default.error }));
        return null;
    }, [passStatus, isPassStatusAvailable]);
    const scoreBit = (0, react_1.useMemo)(() => {
        if (!isScoreAvailable)
            return null;
        return (react_1.default.createElement(Text_1.default, { variant: "h2" },
            react_1.default.createElement("span", null, lib_i18n_1.default.t('score')),
            ": ",
            scoreText));
    }, [isScoreAvailable, scoreText]);
    const gradeBit = (0, react_1.useMemo)(() => {
        if (!isGradeAvailable)
            return null;
        return (react_1.default.createElement(Text_1.default, { variant: "h2" },
            react_1.default.createElement("span", null, lib_i18n_1.default.t('grade')),
            ": ",
            grade.title));
    }, [grade, isGradeAvailable]);
    const percentCircle = (0, react_1.useMemo)(() => react_1.default.createElement(PercentCircle_1.default, { percent: percentCompleted, label: percentCompleted + '%' }), [percentCompleted]);
    const handleSubmit = (0, react_1.useCallback)(() => {
        if (!self.isStaff) {
            setShowStaffListDialog(true);
        }
        else {
            doSubmit();
        }
    }, [doSubmit, self]);
    const handleClose = (0, react_1.useCallback)(() => {
        setShowStaffListDialog(false);
    }, []);
    const handleSelectStaff = (0, react_1.useCallback)((staff, userImage) => {
        doUpdateSubmittingUser(staff);
        if (userImage) {
            doSetUserImage(userImage);
        }
        setShowStaffListDialog(false);
        doSubmit();
    }, [doSubmit, doUpdateSubmittingUser, doSetUserImage]);
    const submitButton = (0, react_1.useMemo)(() => (react_1.default.createElement(Button_1.default, { style: { pointerEvents: submitting ? 'none' : undefined }, classes: { root: myCss.submitButton }, disabled: saving, loading: submitting, color: submitting ? lib_palette_1.default.secondary : lib_palette_1.default.primary, icon: react_1.default.createElement(PlayIcon_1.default, null), label: submitting ? lib_i18n_1.default.t('op-submitting') : lib_i18n_1.default.t('submit-op'), onClick: handleSubmit })), [handleSubmit, myCss, submitting, saving]);
    const submittedButton = (0, react_1.useMemo)(() => (react_1.default.createElement(Button_1.default, { color: lib_palette_1.default.positive, classes: { root: myCss.submitButton }, style: { pointerEvents: 'none' }, label: lib_i18n_1.default.t('submitted') })), [myCss]);
    const mainButton = isCompleted && !hasError ? propsSubmitButton !== null && propsSubmitButton !== void 0 ? propsSubmitButton : submitButton : percentCircle;
    const showScoreBar = isPassStatusAvailable || isScoreAvailable || isGradeAvailable;
    return (0, react_1.useMemo)(() => (react_1.default.createElement(react_1.default.Fragment, null,
        !!canBePerformedOnlyOnNative ? (react_1.default.createElement(Pane_1.default, { padding: true, classes: { root: myCss.nativeOnlyMessage } },
            react_1.default.createElement(Text_1.default, { withBreaks: true, color: "error", variant: "h2" }, lib_i18n_1.default.t('performed-only-native')))) : (react_1.default.createElement(Vertical_1.default, { shrink: true, classes: { root: myCss.root } },
            children,
            !isSubmitted ? (react_1.default.createElement(Horizontal_1.default, { classes: { root: myCss.topBar }, centered: true, shrink: true, gutter: true, padding: true },
                isCompleted ? (react_1.default.createElement(Pane_1.default, { grow: true, classes: { root: myCss.completedMsg } },
                    react_1.default.createElement(Text_1.default, { withBreaks: true, variant: "h2" }, submitMessage !== null && submitMessage !== void 0 ? submitMessage : lib_i18n_1.default.t('submit-op-text')))) : (react_1.default.createElement(Vertical_1.default, { gutter: true, classes: { root: myCss.notCompletedMsg } },
                    react_1.default.createElement(Text_1.default, { withBreaks: true, variant: "h1" }, title),
                    react_1.default.createElement(Pane_1.default, null,
                        react_1.default.createElement(DataPill_1.default, { value: placeTitle, type: DataType_1.default.PLACE })))),
                react_1.default.createElement(Pane_1.default, null, mainButton))) : null,
            showScoreBar ? (react_1.default.createElement(Horizontal_1.default, { centered: true, shrink: true, gutter: true, padding: true },
                passFailIcon,
                scoreBit,
                gradeBit,
                isSubmitted ? submittedButton : null)) : null)),
        showStaffListDialog && (react_1.default.createElement(PickStaffDialog_1.default, { onSelectStaff: handleSelectStaff, onClose: handleClose })))), [
        canBePerformedOnlyOnNative,
        myCss,
        children,
        isSubmitted,
        isCompleted,
        submitMessage,
        placeTitle,
        title,
        mainButton,
        showScoreBar,
        passFailIcon,
        scoreBit,
        gradeBit,
        submittedButton,
        showStaffListDialog,
        handleSelectStaff,
        handleClose,
    ]);
}
exports.OpPerformHeader = OpPerformHeader;
exports.default = OpPerformHeader;
const passFailIconProps = {
    size: 32,
    style: {
        backgroundColor: lib_palette_1.default.White.main,
        borderRadius: '50%',
    },
};
